module.exports = "### Simplicity, Quality, Speed — Pick Three\n\nPeople expect modern, engaging experiences that work.\nMineral makes this easier by providing common patterns, reusable components and\ndesign guidelines that are visually appealing, consistent and easy to use.\n\nBy using individually consumable React components, teams can build, launch, and\nmaintain high quality experiences with greater speed and efficiency.\n\n<CTALink to=\"/color\">\n  Discover how our guidelines can help your next project\n  <IconChevronRight size=\"large\" />\n</CTALink>\n"


//////////////////
// WEBPACK FOOTER
// ./src/website/app/pages/Home/content/guidelines.md
// module id = 512
// module chunks = 9